<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'" :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
      <el-form-item label="货号" prop="prd_no">
        <el-input v-model="dataForm.prd_no" placeholder="货号"></el-input>
      </el-form-item>
      <el-form-item label="分类" prop="type">
        <el-input v-model="dataForm.type" placeholder="分类"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api/frsendgoodsapi/prono.js";
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        prd_no: "",
        type: "",
      },
      dataRule: {
        prdNo: [{ required: true, message: "货号不能为空", trigger: "blur" }],
        type: [{ required: true, message: "分类不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0;
      this.visible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          api.info(this.dataForm.id).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.prd_no = data.data.prd_no;
              this.dataForm.type = data.data.type;
              this.dataForm.createid = data.data.createid;
              this.dataForm.cretatetime = data.data.cretatetime;
              this.dataForm.updateid = data.data.updateid;
              this.dataForm.updatetime = data.data.updatetime;
              this.dataForm.isdelete = data.data.isdelete;
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.dataForm.id) {
            api.update(this.dataForm).then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
                    this.$emit("refreshDataList");
                  },
                });
              } else {
                this.$message.error(data.message);
              }
            });
          } else {
            api.add(this.dataForm).then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  onClose: () => {
                    this.visible = false;
                    this.$emit("refreshDataList");
                  },
                });
              } else {
                this.$message.error(data.message);
              }
            });
          }
        }
      });
    },
  },
};
</script>
